export const CheckLogin = "CHECK_LOGIN";
export const AuthenticateSuccess = "AUTHENTICATE_SUCCESS";
export const AuthenticateError = "AUTHENTICATE_ERROR";
export const ToggleContactModal = "TOGGLE_CONTACT_MODAL";
export const ToggleTermsOfUseModal = "TOGGLE_TERMS_OF_USE_MODAL";
export const SetPassword = "SET_PASSWORD";
export const SetPasswordSuccess = "SET_PASSWORD_SUCCESS";
export const SetPasswordError = "SET_PASSWORD_ERROR";
export const SetAccessTokenExpiresAt = "SET_ACCESS_TOKEN_EXPIRES_AT";
export const Impersonate = "IMPERSONATE";
export const ImpersonateSuccess = "IMPERSONATE_SUCCESS";
export const ImpersonateError = "IMPERSONATE_ERROR";
